module.exports = __webpack_public_path__ + "static/img/shl_certificate_team.18048e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_certificate_team.jpg
// module id = AgLs
// module chunks = 5